/**
 * Fabricated `/mock-players/` headshots are for local Daily Reveal testing only.
 * Must never be preferred (or shipped) in production builds.
 */
export function areMockPlayerAssetsAllowed(): boolean {
  return import.meta.env.DEV === true;
}

export function isMockPlayerAssetUrl(url: string | null | undefined): boolean {
  return typeof url === 'string' && url.startsWith('/mock-players/');
}
